<template>
  <div class="hbb_indexCon" @dragover="fileDragover" @drop="fileDrop">
    <div class="sdw_paste_container">
      <div class="hbb_parse hbb_parseq" v-if="!showSuccessImg">
        <img class="imgS" src="@assets/images/icon_pic.png" alt />
        <p>截图粘贴VIN码图片到这试试呗</p>
        <p style="font-size: 12px; color: #e74c3c; margin-top: 5px">
          微信中使用快捷键Alt+A截图后，再Ctrl+V粘贴到这里
        </p>
        <p style="font-size: 12px; color: #e74c3c; margin-top: 5px">
          拍完整铭牌，解析更精准
        </p>
      </div>
      <div class="hbb_parse1 hbb_parseq" v-else>
        <img
          :class="isDistinguish ? 'distinguishSuccess' : 'imgS'"
          :src="showSuccessImg"
          alt
        />
        <div class="textBox" v-if="!isDistinguish">
          <p>图片无法识别,给您带来不便请谅解,您可以换张图试试!</p>
          <div>
            <span>如果您的图片上存在以下问题,也会影响到图片识别结果哦!</span>
            <span>1.图片上的VIN码不完整</span>
            <span>2.图片上的VIN码不清晰</span>
          </div>
          <el-button
            type="primary"
            @click="againClick"
            style="padding: 0 20px; margin-top: 20px"
            >再试一次</el-button
          >
        </div>
      </div>
      <!-- <img class="imgS" src="@assets/images/icon_pic.png" alt />
      <p>点击上传图片</p>-->
      <el-upload
        class="sdw_avatar_uploader"
        :action="apiDomian + '/api/Common/SaveImage'"
        :on-preview="handlePreview"
        :on-remove="handleRemove"
        :on-success="handleSuccess"
        :before-remove="beforeRemove"
        :before-upload="beforeAvatarUpload"
        :show-file-list="false"
        accept=".jpg, .jpeg, .png, .gif, .JPG, .JPEG, .PBG, .GIF"
        multiple
        :limit="100"
        :on-exceed="handleExceed"
      >
        <div class="sdw_avatar_uploader_fill">
          <img
            class="sdw_avatar_uploader_icon"
            src="@assets/images/icon_new.png"
            alt
          />
          <p class="sdw_avatar_uploader_text">点击上传图片</p>
        </div>
      </el-upload>
    </div>
    <div class="hbb_tuShi">图片示例</div>
    <p class="hbb_tip">
      上传/粘贴的图片请尽量高清，VIN码部分尽量避免高光丶反光丶弱光等影响识别结果的情况
    </p>
    <div class="hbb_li">
      <div class="d">
        <img src="@assets/images/pic_01.png" alt />
      </div>
      <div class="d">
        <img src="@assets/images/pic_02.png" alt />
      </div>
      <div class="d">
        <img src="@assets/images/pic_03.png" alt />
      </div>
      <div class="d">
        <img src="@assets/images/pic_04.png" alt />
      </div>
    </div>
    <!-- <div class="hbb_up">
      <el-upload
        class="upload-han"
        :action="uploadDomian + '/wms/api/FileUpLoad/UpFileToOSS'"
        :on-preview="handlePreview"
        :on-remove="handleRemove"
        :on-success="handleSuccess"
        :before-remove="beforeRemove"
        accept=".jpg, .jpeg, .png, .gif, .JPG, .JPEG, .PBG, .GIF"
        multiple
        :limit="100"
        :on-exceed="handleExceed"
      >
        您还可以选择
        <el-button style="padding:0 20px;" :disabled="distinguishModal">上传图片</el-button>
      </el-upload>
    </div>-->
    <!-- 识别弹框 -->
    <Modal :text="modalText" v-if="distinguishModal" class="hbb"></Modal>

    <!-- <el-dialog
      title="VIP会员（购买VIP，无限制查询）"
      :visible.sync="isPaymentShow"
      v-if="isPaymentShow"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="630px"
      @close="PayhandleClose()"
      :modal-append-to-body="false"
      append-to-body
    >
      <payment ref="payment" @PaySuccess="On_PaySuccess()"></payment>
    </el-dialog>

    <el-dialog
      title="VIP会员"
      width="750px"
      :visible.sync="isPaySuccessShow"
      v-if="isPaySuccessShow"
      :before-close="handleClose"
      :modal-append-to-body="false"
      append-to-body
    >
      <div class="wrapper_box">
        <div class="wrapper-view">
          <img
            class="wrapp-img"
            src="@assets/images/icon_success1.png"
            alt=""
          />
          <p class="wrapp-main">购买智配Store VIP成功</p>
          <p class="wrapp-min">您可以在会员期内不限次数查询</p>
        </div>
      </div>
    </el-dialog> -->
    <el-dialog
        :visible.sync="isVinLoading"
        v-if="isVinLoading"
        width="30%"
        center
        class="vin-loading-page"
        :show-close="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        append-to-body
    >
      <VinLoading v-if="isVinLoading" :vinCode="vinCode" @success="vinLoadingSuccess" @fail="vinLoadingFail"></VinLoading>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import Modal from "@components/Modal/Index";
import server from "@/utils/server";
import payment from "@components/payment/payment";
import VinLoading from "@components/VinLoading/VinLoading";
import * as imageConversion from 'image-conversion';
export default {
  components: {
    Modal,
    payment,
    VinLoading,
  },
  data() {
    return {
      baseUrl:
        process.env.NODE_ENV === "development"
          ? ""
          : process.env.VUE_APP_API_DOMAIN,
      apiDomian: process.env.VUE_APP_API_DOMAIN, // 不同环境走不同的地址 [仅供上传]
      fileIdsList: [], // 存放上传图片的集合
      showSuccessImg: "", // 上传成功的图片

      isDistinguish: false, // 判断是否识别成功
      distinguishModal: false, // 正在识别中的弹框
      vinCode: "", // 当前车型的vin码
      vincodeQuery: this.$route.query.v, // 查询vin码 用于管控页面的前进后退 params
      query_mode: this.$route.query.mode, // 启动模式 inshop: 代表门店启动的嵌入模式
      modalText: "图片识别中...",
      MAX_FILE_SIZE: 5 * 1000 * 1000, // 不可上传超过10M
      IsVip: false, //是否VIP
      isPaymentShow: false, //是否支付中
      // isPaySuccessShow: false, // 是否支付成功
      totalTime: 3,
      hostDomian: process.env.VUE_APP_API_DOMAIN, // 不同环境走不同的地址
      isVinLoading:false,
      vinLoading_input:{},
      COMPRESS_MAX_FILE_SIZE: 3 * 1024 * 1024,
      compressAccuratelySize:3072  //压缩限制单位kb 最大3Mb
    };
  },
  computed: {
    ...mapGetters({
      carNumber: "CommonModule/getcarNumber",
      requestData: "CommonModule/getRequestData",
      viewModalOver: "CommonModule/getViewModalOver",
    }),
  },
  created() {
    let _this = this;
    _this.$nextTick(() => {
      _this.parseImg();
    });
  },
  mounted() {
    if (this.vincodeQuery) {
      this.initData();
    } else {
      return false;
    }
  },

  methods: {
    ...mapMutations({
      setCarNumber: "CommonModule/SET_CARNUMBER",
      setViewModalOver: "CommonModule/SET_VIEWMODALOVER",
      setRequestData: "CommonModule/SET_REQUESTDATA",
    }),
    ...mapActions({
      SearchAuto: "SearchResultModule/SearchAuto",
      GetCjmlAutoValidPartAndParam:
        "SearchResultModule/GetCjmlAutoValidPartAndParam",
      CheckVinByVinCode: "SearchResultModule/CheckVinByVinCode",
      CheckVinByFile: "SearchResultModule/CheckVinByFile",
    }),
    vinLoadingSuccess(vinCode){
      console.log("vinLoading: "+vinCode)
      this.isVinLoading = false
      this.checkVin(vinCode);
    },
    vinLoadingFail(){
      this.isVinLoading = false
      this.$message.error("vin码解析失败！")
    },
    async beforeAvatarUpload(file) {
      if (file.size > this.COMPRESS_MAX_FILE_SIZE) {
        return new Promise(async (resolve) => {
         let files = await this.compressAccurately(file, this.compressAccuratelySize)
          const isLt5M = files.size / 1024 / 1024 < 5;
          if (!isLt5M) {
            this.$message.error("上传图片大小不能超过 5MB!");
            return false;
          }else {
            resolve(files)
          }
        });
      } else {
        return new Promise((resolve) => {
          resolve(file)
        })
      }
    },
    handleSuccess(response, file, fileList) {
      let _this = this;
      if (response.success) {
        _this.$message({
          type: "success",
          message: "上传成功",
          duration: 2000,
        });
        let updateImg = response.VisitUrl;
        _this.DistinguishFn(updateImg, 2);
      } else {
        _this.$message({
          type: "warning",
          message: response.Message,
        });
        _this.isDistinguish = false;
        _this.distinguishModal = false;
      }
    },
    againClick() {
      // Vin码识别失败再来一次
      this.showSuccessImg = "";
      this.isDistinguish = false;
    },
    checkVin(vinCode) {
      let url = `${
        this.apiDomian
      }/#/SearchResult?v=${vinCode}&ht=${Date.now()}&mode=${this.query_mode}`;
      location.href = url;
    },
    PayhandleClose() {
      this.$refs.payment.clearPayQuey();
    },
    //关闭
    // On_PaySuccess() {
    //   this.isPaymentShow = false;
    //   this.isPaySuccessShow = true;
    //   window.setInterval(() => {
    //     this.totalTime--;
    //     if (this.totalTime == 0) {
    //       this.toDepositManageList();
    //     }
    //   }, 1000);
    // },
    //跳转到列表页
    toDepositManageList() {
      let href = this.hostDomian + "#/SearchResult";
      top.location.href = href;
    },
    initData() {
      let _this = this;
      server.myAxios("/api/UserCenter/GetIsVip").then((resitem) => {
        if (!resitem) {
          //非VIP
          _this.isPaymentShow = true;
          //记录行为日志-引导支付 被动
          _this.WriteVvipBehaviorLog_guidepay("passive");
        } else {
          //是VIP
          _this.modalText = "VIN码识别中...";
          _this.distinguishModal = true;
          let request_data = {
            vinCode: _this.vincodeQuery,
          };
          this.SearchAuto(request_data)
            .then((res) => {
              _this.isVerify = true;
              _this.distinguishModal = false;
              _this.isDistinguish = true;
              _this.setCarNumber(_this.carNumber + 1);
              console.log(`emit DistinguishSuccess res`, res);
              console.log(
                `emit DistinguishSuccess requestData`,
                _this.requestData
              );
              // 每个品类都设置为待完善和隐藏
              if (res && res.validCategorys) {
                res.validCategorys.forEach((oneCategory) => {
                  oneCategory.waitFill = true;
                  oneCategory.isDisplaying = false;
                  oneCategory.loading = false;
                });
              }
              _this.$emit("DistinguishSuccess", res, _this.requestData);
            })
            .catch((err) => {
              _this.setViewModalOver(true);
              _this.isDistinguish = false;
              _this.$emit("DistinguishFail", err);
              _this.distinguishModal = false;
              if (_this.requestData.type == 1 && this.showSuccessImg) {
                this.showSuccessImg = "";
              }
            });
        }
      });
    },

    DistinguishFn(resSrc, type, isRecod) {
      // 识别图片方法 请求后台接口 type VIN码=1;VIN码图片=2;base64=3   isRecod: 是否点击扫码记录
      // verifyData 只是用于在验证成功做的桥梁
      // 跳转之后 重新拉取数据
      let _this = this;

      let verifyData = {
        resSrc: resSrc,
        type: type,
        isRecod: isRecod,
      };
      _this.setRequestData(verifyData);
      if (isRecod) {
        _this.distinguishModal = false;
      } else {
        _this.distinguishModal = true;
      }
      // 只要查询成功过一次 那么carNumber++ 就代表可以重复点击黏贴图片事件
      if (type == 1) {
        _this.modalText = "VIN码识别中...";
        _this.showSuccessImg = "";
      } else {
        _this.modalText = "图片识别中...";
        _this.showSuccessImg = resSrc;
      }
      if (type == 1 && resSrc.length !== 17) {
        _this.$message({
          type: "warning",
          message: "VIN码长度必须为17位",
        });
        _this.distinguishModal = false;

        _this.setViewModalOver(true);
        return false;
      }

      _this.distinguishModal = true;
      _this.setViewModalOver(false);
      _this.isDistinguish = true;
      let request_data = {
        searchInput: resSrc,
        source: isRecod ? "smjl" : "sdsr", //来源 扫码记录 or 手动输入
      };
      if (type == 1) {
        this.CheckVinByVinCode(request_data)
          .then((res) => {
            console.log(res.isNeesWaiting)
            if (res.isNeesWaiting){
              console.log('openLoading')
              _this.distinguishModal = false;
              _this.setViewModalOver(true);
              _this.isVinLoading = true
              _this.vinCode = res.vinCode
            }else {
              _this.checkVin(res.vinCode);
            }
          })
          .catch((err) => {
            _this.setViewModalOver(true);
            _this.isDistinguish = false;
            _this.$emit("DistinguishFail", err);
            _this.distinguishModal = false;
            if (_this.requestData.type == 1 && this.showSuccessImg) {
              _this.showSuccessImg = "";
            }
          });
      } else {
        _this
          .CheckVinByFile(request_data)
          .then((res) => {
            if (res.isNeesWaiting){
              console.log('openLoading')
              _this.distinguishModal = false;
              _this.setViewModalOver(true);
              _this.isVinLoading = true
              _this.vinCode = res.vinCode
            }else {
              _this.checkVin(res.vinCode);
            }
          })
          .catch((err) => {
            _this.setViewModalOver(true);
            _this.isDistinguish = false;
            _this.$emit("DistinguishFail", err);
            _this.distinguishModal = false;
            if (_this.requestData.type == 1 && this.showSuccessImg) {
              _this.showSuccessImg = "";
            }
          });
      }
      // this.checkVin();
    },
    // 拖拽上传
    fileDragover(e) {
      e.preventDefault();
    },
    async fileDrop(e) {
      e.stopPropagation();
      e.preventDefault();

      let _this = this;
      const file = e.dataTransfer.files[0]; // 获取到第一个上传的文件对象
      if (!file) return;
/*      if (file.size > this.MAX_FILE_SIZE) {
        return alert("文件大小不能超过10M");
      }*/
      let imageFile
      if (file.size > this.COMPRESS_MAX_FILE_SIZE) {
        imageFile = await this.compressAccurately(file,this.compressAccuratelySize)
      } else {
        imageFile = file;
      }
      if (imageFile.size > this.MAX_FILE_SIZE) {
        return alert("文件大小不能超过5M");
      }
      server.updatedFile(imageFile).then((res) => {
        _this.showSuccessImg = res.VisitUrl;
        _this.DistinguishFn(_this.showSuccessImg, 2);
      });
      var reader = new FileReader();
      reader.onload = function (e) {
        _this.showSuccessImg = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    async parseFn(e) {
      // 粘贴方法
      let _this = this;
      // 首次初始化页面数据模拟加载完
      if (_this.carNumber == 1) {
        _this.setViewModalOver(true);
      }
      // 如果页面数据没有加载完 我不允许你恶意攻击我的代码
      if (!_this.viewModalOver) {
        return false;
      }
      var cbd = e.clipboardData;
      var ua = window.navigator.userAgent;
      // 如果是 Safari 直接 return
      var blob;
      if (!(e.clipboardData && e.clipboardData.items)) {
        return;
      }
      // Mac平台下Chrome49版本以下 复制Finder中的文件的Bug Hack掉

      if (
        cbd.items &&
        cbd.items.length === 2 &&
        cbd.items[0].kind === "string" &&
        cbd.items[1].kind === "file" &&
        cbd.types &&
        cbd.types.length === 2 &&
        cbd.types[0] === "text/plain" &&
        cbd.types[1] === "Files" &&
        ua.match(/Macintosh/i) &&
        Number(ua.match(/Chrome\/(\d{2})/i)[1]) < 49
      ) {
        return;
      }

      for (var i = 0; i < cbd.items.length; i++) {
        var item = cbd.items[i];

        if (item.kind == "file") {
          blob = item.getAsFile();
          if (blob.size === 0) {
            return;
          }

          var reader = new FileReader();
          var imgs = new Image();
          imgs.file = blob;
          reader.onload = (function (aImg) {
            return function (e) {
              aImg.src = e.target.result;
              _this.showSuccessImg = e.target.result;
            };
          })(imgs);
          // reader.readAsDataURL(blob);
          // document.querySelector(obj).innerHTML = '';
          // document.querySelector(obj).appendChild(imgs);
        }
      }
      // 如果他粘贴的不是文件 直接走手动查询的
      if (!blob) {
        return false;
      }
      let imageFile
      if (blob.size > this.COMPRESS_MAX_FILE_SIZE) {
        imageFile =await this.compressAccurately(blob,this.compressAccuratelySize)
      } else {
        imageFile = blob;
      }
      if (imageFile.size > this.MAX_FILE_SIZE) {
        return alert("文件大小不能超过5M");
      }
      _this.$emit("modeOpen", 2);
      server.updatedFile(imageFile).then((res) => {
        _this.showSuccessImg = res.VisitUrl;
        _this.DistinguishFn(_this.showSuccessImg, 2);
      });
    },
    parseImg() {
      let _this = this;
      document
        .querySelector("body")
        .addEventListener("paste", _this.parseFn, false);
    },
    //记录行为日志-引导支付
    WriteVvipBehaviorLog_guidepay(Property) {
      server
        .myAxios("/api/BehaviorLog/WriteVvipBehaviorLog", {
          BehaviorType: "ydzf",
          BehaviorProperty: Property,
        })
        .then((res) => {
          //do nothing
        });
    },
    async compressAccurately(inputFile, toSize) {
      console.log(toSize)
      const resAvatarBlob = await imageConversion.compressAccurately(inputFile, parseInt(toSize));
      const resAvatarFile = new File(
          [resAvatarBlob],
          inputFile.name,
          { type: inputFile.type },
      );
      resAvatarFile.uid = inputFile.uid
      console.log("图片已压缩：", resAvatarFile)
      return resAvatarFile;
    },
  },
};
</script>

<style>
.hbb_indexCon {
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  flex-direction: column;
}

.sdw_paste_container {
  width: 100%;
  padding-top: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.sdw_avatar_uploader {
  margin-left: 16px;
  position: relative;
}

.hbb_parse {
  display: flex;
  width: 500px;
  height: 300px;
  border: 1px dashed #e74c3c;
  /* margin-top: 80px; */
  border-radius: 10px;
  background: #fff9f9;
  flex-direction: column;
  position: relative;
  align-items: center;
}

.hbb_parse img.imgS {
  width: 50px;
  height: 50px;
  border-radius: 10px;
  margin: 90px 0 20px 0;
}

.hbb_parse p {
  /* font-weight: bold; */
  font-size: 16px;
}

.sdw_avatar_uploader .el-upload {
  border-radius: 6px;
  border: 1px dashed #ebebeb;
  background-color: #fafafa;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.sdw_avatar_uploader .el-upload:hover {
  border-color: #409eff;
}

.sdw_avatar_uploader .sdw_avatar_uploader_fill {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 48px;
  padding-top: 16px;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.sdw_avatar_uploader .sdw_avatar_uploader_icon {
  width: 48px;
  height: 48px;
}

.sdw_avatar_uploader .sdw_avatar_uploader_text {
  font-size: 14px;
}

.hbb_tuShi {
  margin: 20px 0;
  letter-spacing: 2px;
}

.hbb_tip {
  color: #e74c3c;
  font-size: 12px;
  margin-bottom: 20px;
  /* font-weight: bold; */
}

.hbb_li {
  display: flex;
  width: 600px;
  justify-content: space-between;
  margin-left: -10px;
  margin: 10px 0;
}

.hbb_li img {
  max-width: 100%;
  max-height: 100%;
}

.hbb_li .d {
  margin-left: 10px;
  border-radius: 8px;
  position: relative;
  overflow: hidden;
}

.hbb_li .d .t {
  width: 100%;
  height: 20px;
  z-index: 9;
  text-align: center;
  line-height: 20px;
  font-size: 12px;
  color: #ddd;
  background: rgba(0, 0, 0, 0.5);
  left: 0;
  bottom: 0;

  position: absolute;
}

.hbb_up {
  margin-top: 20px;
  font-size: 14px;
}

.hbb_up .el-button {
  border: 1px solid #e74c3c;
  color: #e74c3c;
  margin-left: 10px;
  border-radius: 3px;
  font-size: 14px;
}

.hbb_up .el-button:hover {
  color: #fff;
}

.hbb_parse1 {
  display: flex;
  /* margin-top: 10%; */
  width: 750px;
  align-items: center;
  padding: 20px;
  border: 1px dashed #ddd;
  border-radius: 10px;
  background: #f8f8f8;
  position: relative;
}

.hbb_parse1 img.imgS {
  width: auto;
  max-width: 200px;
  margin-right: 20px;
}

.hbb_parse1 .textBox p {
  font-weight: bold;
  font-size: 16px;
  margin-bottom: 15px;
}

.hbb_parse1 .textBox div {
  display: flex;
  flex-direction: column;
  color: #e74c3c;
  font-size: 12px;
}

.hbb_parse1 .textBox div span {
  font-weight: bold;
  margin-bottom: 8px;
}

.hbb_parse1 img.distinguishSuccess {
  width: auto;
  max-width: 100%;
  max-height: 300px;
  margin: 0 auto;
}
.upload-han .el-upload-list__item-name {
  display: none;
}
.upload-han
  .el-upload-list__item.is-success
  .el-upload-list__item-status-label {
  display: none;
}
.vin-loading-page .el-dialog__header {
  border-bottom: none;
}
</style>
